<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     费用中心-发票申请
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="expense-invoice-apply" style="margin-bottom: 84px;">
    <div class="main-header">
      <div class="title">
        <f-back />
        <span>{{ $route.meta.title }}</span>
      </div>
      <div class="toolbox">&nbsp;</div>
    </div>

    <el-steps
      style="margin-bottom: 20px;"
      :active="currentStep"
      finish-status="success"
      process-status="success"
      simple>
      <el-step title="勾选订单" />
      <el-step title="填写发票信息" />
      <el-step title="确认提交" />
    </el-steps>

    <div v-show="currentStep === 0">
      <el-alert v-if="currentStep === 0" title="警告提示的文案" type="warning" show-icon :closable="false">
        <template slot="title">
          <p>根据《国家税务总局上海市税务局关于进一步开展全面数字化的电子发票试点工作的公告》要求，我司将不再开具纸质发票，感谢您的理解和支持！</p>
        </template>
      </el-alert>
      <el-alert v-if="currentStep === 0" type="info" :closable="false" class="mt-md">
        <template slot="title">
          <p>1 单个订单不可拆分开票</p>
          <p>2 发票基于已支付订单、可开票金额为订单实际支付金额。</p>
          <p>3 系统将根据产品类型、适用税率等因素，自动生成不确认数量的发票申请。</p>
        </template>
      </el-alert>
      <el-card v-loading="loading" class="mt-md" shadow="never">
        <div class="text-muted" style="padding-left: 14px">有 <span>{{ list.length }}</span> 个订单可申请发票，可开票总额： <span>{{ amountTotal | currency }}</span></div>
        <el-table
          ref="listTable"
          :data="list"
          style="width: 100%"
          @selection-change="onTableSectionChange"
          @row-click="onRowClick">
          <el-table-column type="selection" width="50" />
          <el-table-column label="订单号" width="200" prop="order_sn" />
          <el-table-column label="主题" min-width="300" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.subject }}
            </template>
          </el-table-column>
          <el-table-column label="支付方式" min-width="160">
            <template slot-scope="scope">
              <span>{{ paymentTypeObj[scope.row.payment_type] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="支付时间" min-width="160">
            <template slot-scope="scope">
              {{ scope.row.pay_time | parseTime('{y}/{m}/{d} {h}:{i}') }}
            </template>
          </el-table-column>
          <el-table-column label="可开票金额" min-width="120" align="right">
            <template slot-scope="scope">
              <span>{{ scope.row.order_amount_payed | currency }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>

    <div v-show="currentStep === 1">
      <el-alert type="info" :closable="false">
        <template slot="title">
          <p class="font-lg" style="color: #333">
            开票订单数量 <span class="text-danger">{{ tableSelection.length }}</span>， 开票总金额 <span class="text-danger">{{ amountTotalSelected | currency }}</span>
          </p>
        </template>
      </el-alert>

      <el-card v-loading="loading" :body-style="{ margin: '20px' }" class="mt-md" shadow="never">
        <el-form
          ref="invoiceForm"
          label-position="left"
          label-width="120px"
          :rules="invoicerules"
          :model="invoice">
          <el-form-item label="发票类型" prop="invoice_type">
            <el-radio-group v-model="invoice.invoice_type">
              <el-radio :label="5">增值税电子专用发票</el-radio>
              <el-radio :label="4">增值税电子普通发票</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发票抬头" prop="corporate_name">
            <el-col :span="17">
              <el-input v-model="invoice.corporate_name" placeholder="名称" />
            </el-col>
          </el-form-item>
          <el-form-item label="纳税人识别号" prop="corporate_code">
            <el-col :span="17">
              <el-input v-model="invoice.corporate_code" placeholder="税号" />
            </el-col>
          </el-form-item>
          <el-form-item label="地址、电话">
            <el-col :span="10">
              <el-input v-model="invoice.detail_address" placeholder="地址" />
            </el-col>
            <el-col :span="6" :offset="1">
              <el-input v-model="invoice.telephone" placeholder="电话" />
            </el-col>
          </el-form-item>
          <el-form-item label="开户行及账号">
            <el-col :span="10">
              <el-input v-model="invoice.bank" placeholder="开户行" />
            </el-col>
            <el-col :span="6" :offset="1">
              <el-input v-model="invoice.bank_account" placeholder="账号" />
            </el-col>
          </el-form-item>
        </el-form>
      </el-card>

      <el-card class="mailbox mt-md" shadow="never">
        <el-form
          ref="mailForm"
          label-position="left"
          label-width="120px"
          :rules="mailrules"
          :model="mailbox">
            <el-form-item label="接收邮箱" prop="email">
              <el-col :span="17">
                <el-input v-model="mailbox.email" placeholder="邮箱" />
              </el-col>
            </el-form-item>
          </el-form>
      </el-card>
    </div>

    <div class="apply-footer">
      <el-row v-show="currentStep === 0" style="width: 100%;">
        <el-col :span="8" :offset="8" class="text-center">
          <p>
            <el-button type="primary" :disabled="tableSelection.length === 0" @click="onSelectOrderComplete">下一步</el-button>
          </p>
        </el-col>
        <el-col :span="8" class="text-right" style="padding-right: 60px;">
          <p>
            <span>待开票金额：</span>
            <span class="span font-2x" :class="{ 'text-warning': amountTotalSelected > 0 }">{{ amountTotalSelected | currency }}</span>
          </p>
        </el-col>
      </el-row>
      <p v-show="currentStep === 1" class="text-center ml-md">
        <el-button @click="currentStep = 0">上一步</el-button>
        <el-button type="primary" @click="onApplySubmit">确认提交</el-button>
      </p>
    </div>
  </div>
</template>

<script>
import FGodAddressPicker from '@/views/fam/components/FGodAddressPicker'
import { getUninvoicedOrderListApi, applyOrderInvoiceApi } from '@/api/expense/expenseOinvoiceApi'
export default {
  name: 'ExpenseOinvoiceApply',
  components: {
    FGodAddressPicker
  },
  data() {
    var checkEmail = (rule,value,cb) => {
      //验证邮箱的正则表达式
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if(regEmail.test(value)){
        //合法的邮箱
        return cb();
      }
      //邮箱不合法
      cb(new Error('邮箱格式不正确'));
    }
    return {
      loading: false,
      currentStep: 0,
      total: 0,
      list: [],
      tableSelection: [],
      invoice: {},
      invoicerules: {
        corporate_name: [
          {required: true, message: '发票抬头不能为空', trigger: 'blur' },
        ],
        corporate_code: [
          {required: true, message: '税号不能为空', trigger: 'blur' },
        ]
      },
      mailbox: {
        email: ""
      },
      mailrules: {
        email: [ 
          {required: true, message: '请输入邮箱', trigger: 'blur' },
          {validator: checkEmail, trigger: 'blur'}
        ]
      },
    }
  },
  computed: {
    invoiceTypeObj() {
      return this.$store.getters.invoiceTypeObj
    },
    paymentTypeObj() {
      return this.$store.getters.paymentTypeObj
    },
    amountTotal() {
      return this.list.reduce((acc, cur) => {
        acc += parseFloat(cur.order_amount_payed)
        return acc
      }, 0)
    },
    amountTotalSelected() {
      return this.tableSelection.reduce((acc, cur) => {
        acc += parseFloat(cur.order_amount_payed)
        return acc
      }, 0)
    },
    isCollapse() {
      return this.$store.state.commonStore.collapse
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      getUninvoicedOrderListApi().then(res => {
        this.loading = false
        if (!res.errno) {
          this.list = res.data.orders
          this.invoice = Object.assign({}, res.data.invoice)
          this.mailbox.email = res.data.email
        }
      })
    },
    onTableSectionChange(val) {
      this.tableSelection = val
    },
    onRowClick(row) {
      this.$refs.listTable.toggleRowSelection(row)
    },
    onSelectOrderComplete() {
      this.currentStep = 1
    },
    onApplySubmit() {
      const formRefs = ['invoiceForm','mailForm']
      let isValid = true
      formRefs.forEach(ref => {
        this.$refs[ref].validate(valid => {
          if (!valid) {
            isValid = false
          }
        })
      })
      if(isValid) {
        this.$confirm(`申请 <span class="text-danger">${this.tableSelection.length}</span> 个订单，可开票总额： <span class="text-danger">¥ ${this.amountTotalSelected}</span>`, '确认提交？', {
          dangerouslyUseHTMLString: true,
          type: 'success'
        }).then(() => {
          applyOrderInvoiceApi({
            orderid: this.tableSelection.map((item) => item.orderid),
            invoice: this.invoice,
            email: this.mailbox.email
          }).then(res => {
            if (!res.errno) {
              // 操作成功处理
              this.$message.success('操作成功！')
              this.$router.push('/expense/invoice')
            } else {
              this.$message.error(res.message)
            }
          })
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }
}
</script>

<style lang="scss" slot-scoped>
.expense-invoice-apply {
  width: 1200px;
  margin: 0 auto;
  .apply-footer {
    width: 1200px;
    margin: 0 auto;
      position: fixed;
      bottom: 0;
      min-height: 48px;
      background-color: #fff;
      border-top: 1px solid #ebeef5;
      box-shadow: 0px 0px 6px 0 rgba(0, 0, 0, 0.05);
      z-index: 210;
      display: flex;
      align-items: center;
  }
}
.mailbox {
  .el-card__body {
    margin: 20px;
    margin-bottom: 0;
  }
}
</style>
